export default function AppDownload() {
  return (
    <section id="app" className="py-16 md:py-24 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16 max-w-5xl mx-auto">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block px-4 py-1.5 rounded-full bg-primary-100/80 text-primary-700 text-xs font-medium mb-4">
              随时随地
            </span>
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading">
              移动观看
            </h2>
            <p className="mt-4 text-sm md:text-base text-foreground-500 leading-relaxed">
              向日葵视频完美适配手机与平板浏览器，无需下载安装任何APP，
              直接在浏览器中打开即可畅享高清观影体验。支持iOS Safari、
              Android Chrome等主流移动浏览器，随时随地追剧不中断。
            </p>
            <p className="mt-3 text-sm text-foreground-400">
              收藏本站到手机桌面，一键直达观影入口，方便快捷。
            </p>

            <div className="mt-8 flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-4">
              <a
                href="#hero"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#hero')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="w-full sm:w-auto px-8 py-3.5 bg-primary-500 text-background-50 font-semibold rounded-full text-sm hover:bg-primary-600 transition-colors text-center whitespace-nowrap cursor-pointer"
              >
                <i className="ri-smartphone-line mr-2"></i>
                立即体验
              </a>
              <a
                href="#features"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#features')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="w-full sm:w-auto px-8 py-3.5 border border-background-300 text-foreground-700 font-medium rounded-full text-sm hover:bg-background-100 hover:border-primary-300 transition-colors text-center whitespace-nowrap cursor-pointer"
              >
                查看特色
                <i className="ri-arrow-right-line ml-2"></i>
              </a>
            </div>

            <div className="mt-6 flex items-center justify-center lg:justify-start gap-4 text-xs text-foreground-400">
              <span className="flex items-center gap-1.5">
                <i className="ri-apple-line text-sm"></i> iOS Safari
              </span>
              <span className="flex items-center gap-1.5">
                <i className="ri-android-line text-sm"></i> Android Chrome
              </span>
              <span className="flex items-center gap-1.5">
                <i className="ri-window-line text-sm"></i> PC浏览器
              </span>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center">
            <div className="relative">
              <div className="absolute -inset-6 bg-gradient-to-br from-primary-300/20 via-accent-200/15 to-secondary-300/20 rounded-3xl blur-2xl"></div>
              <div className="relative w-64 h-auto rounded-2xl overflow-hidden border-4 border-background-200/60 bg-background-100">
                <img
                  src="https://readdy.ai/api/search-image?query=Smartphone%20mockup%20showing%20video%20streaming%20app%20interface%20with%20movie%20thumbnails%20and%20play%20buttons%2C%20warm%20orange%20and%20amber%20UI%20design%2C%20cinematic%20mobile%20app%20screen%2C%20dark%20theme%20with%20warm%20accents%2C%20modern%20phone%20display%2C%20clean%20minimal%20design%2C%20entertainment%20app%20mockup%2C%20no%20visible%20text&width=560&height=980&seq=app-mobile-2026&orientation=portrait"
                  alt="向日葵视频移动端观影体验"
                  className="w-full h-auto object-cover"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}